// Copyright 2016 Sorama B.V.

export class NotSupportedError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "NotSupportedError";
    }
}
